// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC2sbgT4ennzZ1F-Yvbf-kkLaEDpCZIq-0",
  authDomain: "stealth-jobs-mvp.firebaseapp.com",
  projectId: "stealth-jobs-mvp",
  storageBucket: "stealth-jobs-mvp.appspot.com",
  messagingSenderId: "694974326268",
  appId: "1:694974326268:web:4895eae078f03c70d23e79",
  measurementId: "G-3J4VPT7LLL",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
